<script lang="ts">
  // Svelte-стилі з :global() живуть у документі незалежно від того, чи
  // змонтований компонент, тож `:global(body)` з цього екрана фарбував увесь
  // застосунок. Раніше це не було видно — кольори всюди задані явно, а емодзі
  // колір не успадковують. SVG-іконки успадковують, і вони ставали кремовими
  // на кремовому тлі. Тому клас вішаємо на час життя екрана.
  $effect(() => {
    document.body.classList.add('hero-body');
    return () => document.body.classList.remove('hero-body');
  });

  import { TG_LOGIN_LINK, TG_SUPPORT_LINK } from '../lib/bot-links';
  import { BRAND_NAME_LINES, BRAND_TAGLINE } from '../lib/brand';
  import Logo from '../components/Logo.svelte';
</script>

<div class="login-bg">
  <div class="login-content">
    <div class="login-eyebrow">{BRAND_TAGLINE}</div>
    <div class="login-header">
      <Logo size={88} color="var(--text-light)" />
      <div class="login-title">
        {#each BRAND_NAME_LINES as line, i}{#if i > 0}<br />{/if}{line}{/each}
      </div>
    </div>
    <div class="login-sub">Сонце повертається. І ти повертаєшся.</div>
  </div>
</div>

<div class="login-form">
  <a href={TG_LOGIN_LINK} class="btn btn-tg">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
      <path
        d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.447 1.394c-.16.16-.295.295-.605.295l.213-3.053 5.56-5.023c.242-.213-.054-.333-.373-.12l-6.871 4.326-2.962-.924c-.643-.204-.657-.643.136-.953l11.57-4.461c.537-.194 1.006.131.833.941z"
      />
    </svg>
    Увійти через Telegram
  </a>
  <div class="login-link">
    Питання? <a href={TG_SUPPORT_LINK}>Написати в підтримку</a>
  </div>
</div>

<style>
  :global(body.hero-body) {
    background: var(--dark);
    color: var(--text-light);
  }

  /* Герой входу — «схід сонця» з бренд-буку: темне небо, тепле світіння
     з-за горизонту й сама лінія горизонту знизу. Порядок шарів той самий,
     що в mockup/index.html (.login-bg). */
  .login-bg {
    background: linear-gradient(170deg, #12100e 0%, var(--dark) 45%, var(--dark3) 100%);
    padding: 80px 28px 56px;
    color: var(--text-light);
    position: relative;
    overflow: hidden;
    flex: 0 0 auto;
  }
  /* Світіння сонця, що тільки-но виходить з-за горизонту. */
  .login-bg::before {
    content: '';
    position: absolute;
    width: 190px;
    height: 190px;
    border-radius: 50%;
    background: radial-gradient(
      circle at 50% 100%,
      rgba(223, 201, 170, 0.34),
      rgba(223, 201, 170, 0.06) 58%,
      rgba(223, 201, 170, 0) 76%
    );
    left: 50%;
    transform: translateX(-50%);
    bottom: -95px;
  }
  /* Сама лінія горизонту — той самий жест, що у знаку. */
  .login-bg::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 2px;
    background: linear-gradient(
      90deg,
      rgba(223, 201, 170, 0) 0%,
      rgba(223, 201, 170, 0.55) 50%,
      rgba(223, 201, 170, 0) 100%
    );
  }
  .login-content {
    position: relative;
    z-index: 1;
    max-width: 420px;
    margin: 0 auto;
  }
  .login-eyebrow {
    font-size: 10px;
    letter-spacing: 0.3em;
    opacity: 0.62;
    margin-bottom: 18px;
    font-weight: 600;
    text-transform: uppercase;
  }
  .login-header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 12px;
  }
  .login-title {
    font-size: 44px;
    font-weight: 400;
    line-height: 1.08;
    font-family: 'Marcellus', Georgia, serif;
  }
  .login-sub {
    font-size: 14px;
    opacity: 0.65;
    line-height: 1.5;
  }

  .login-form {
    /* Нижня половина екрана — світла, як у мокапі: темний тільки герой.
       Без явного фону сюди просвічував би темний body.hero-body. */
    background: var(--bg);
    color: var(--text);
    padding: 36px 24px 32px;
    flex: 1;
    display: flex;
    flex-direction: column;
    max-width: 420px;
    margin: 0 auto;
    width: 100%;
  }
  .btn {
    width: 100%;
    border: none;
    border-radius: 14px;
    padding: 16px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    letter-spacing: 0.2px;
    font-family: inherit;
  }
  .btn-tg {
    background: #229ed9; /* фірмовий синій Telegram — не наш токен */
    color: var(--text-light);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    text-decoration: none;
    transition: opacity 0.15s;
  }
  .btn-tg:hover {
    opacity: 0.92;
  }
  .login-link {
    text-align: center;
    font-size: 13px;
    color: var(--text-muted);
    margin-top: 22px;
  }
  .login-link a {
    color: var(--accent-text);
    cursor: pointer;
    font-weight: 500;
    text-decoration: none;
  }
  .login-link a:hover {
    text-decoration: underline;
  }

  @media (min-width: 600px) {
    :global(body.hero-body) {
      align-items: center;
      justify-content: center;
      padding: 24px;
      background: radial-gradient(circle at 50% 30%, var(--dark2) 0%, #12100e 70%);
    }
    .login-bg,
    .login-form {
      width: 100%;
      max-width: 480px;
    }
    .login-bg {
      border-radius: 28px 28px 0 0;
      padding: 56px 32px 40px;
    }
    .login-form {
      background: var(--bg);
      color: var(--text);
      border-radius: 0 0 28px 28px;
      padding: 32px 28px 36px;
    }
    .login-link {
      color: var(--text-muted);
    }
  }
</style>
